module.exports = __webpack_public_path__ + "img/titlezh.87706940.png";